import { createAuthFileDownloadQuery } from '../auth-http-client';

export type DownloadBetReportQueryParams = {
	accountIds: number[];
	cashdeskIds: number[];
	gameIds: number[];
	currencies: string[];
	dateFrom: string;
	dateTo: string;
	timeZone: number;
};

export const createDownloadBetReportQuery = () =>
	createAuthFileDownloadQuery<DownloadBetReportQueryParams>({
		url: '/report/bet/download',
		fileName: (params) => `bet-report-${params.dateFrom}-${params.dateTo}.xlsx`,
	});
